import IconTextDescription, { IconTextDescriptionProps } from './IconTextDescription';

export type { IconTextDescriptionProps };
export default IconTextDescription;
